import { z } from 'zod';

export const vehicleLoanCalcTool = z.object({
  Amount: z
    .string({ required_error: 'Arama tutarı giriniz.' })
    .min(1, { message: 'Arama tutarı giriniz.' })
    .transform((value) => value.replace(/\./g, '').replace(',', '.'))
    .refine((value) => !isNaN(Number(value)), {
      message: 'Geçerli bir arama tutarı giriniz.',
    })
    .transform((value) => Number(value))
    .refine((num) => Number.isInteger(num), {
      message: 'Arama tutarı küsuratsız olmalıdır.',
    })
    .refine((num) => num >= 1000, {
      message: "Arama tutarı 1.000 TL'den az olmamalıdır.",
    })
    .transform((value) => String(value)),
  Maturity: z.string({
    required_error: 'Bu alan boş bırakılamaz.',
    invalid_type_error: 'Bu alan boş bırakılamaz.',
  }),
  VehicleStatus: z.string({
    required_error: 'Bu alan boş bırakılamaz.',
    invalid_type_error: 'Bu alan boş bırakılamaz.',
  }),
});
